import Overflow from "components/Layout/Overflow"
import Section from "components/Layout/Section"
import EventsList from "components/pages/events/EventsList"

function UpcomingEventsSection({ events }) {
  return (
    <Section noPadding>
      <Overflow>
        <EventsList events={events} isUpcoming />
      </Overflow>
    </Section>
  )
}

export default UpcomingEventsSection
